import * as React from 'react'

import moment from 'moment'

import FormRow from 'modules/core/components/FormRow'
import DayPicker from 'modules/core/components/Inputs/DayPicker'
import { useMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import type ReportsForm from 'modules/employees/lib/forms/Reports'

interface Props {
  form: ReportsForm
}

const ReferenceDate = ({ form }: Props) => {
  const minDate = useMemo(() => moment().subtract(10, 'years').startOf('year'), [])

  const maxDate = useMemo(() => moment().add(2, 'years').endOf('year'), [])

  return (
    <FormRow>
      <DayPicker
        field={form.get('reference_date')}
        label={i18n.t('employees.reports.reference_date')}
        minDate={minDate}
        maxDate={maxDate}
      />
    </FormRow>
  )
}

export default ReferenceDate
